import { request } from "./request";

export function getAchieves() {
  return request({
    url: '/research/queryResearch',
  })
}

export function delResearch(id) {
  return request({
    url: '/research/delResearch',
    params:{ id }
  })
}

export function insertResearch(title, titleEn, word1, word1En, note1, note1En, word2, word2En, note2, note2En, word3, word3En, note3, note3En, word4, word4En,
                               note4, note4En, word5, word5En, note5, note5En, word6, word6En, note6, note6En, isTop3, createdUser, imgLength) {
  return request({
    url: '/research/insert',
    method: 'post',
    params: {
      title, titleEn, word1, word1En, note1, note1En, word2, word2En, note2, note2En, word3, word3En, note3, note3En, word4, word4En,
      note4, note4En, word5, word5En, note5, note5En, word6, word6En, note6, note6En, isTop3, createdUser, imgLength
    }
  })
}


export function totalResearch() {
  return request({
    url: '/research/totalResearch'
  })
}


export function queryResearch(startIndex, length) {
  return request({
    url: '/research/queryResearch',
    params: { startIndex, length }
  })
}


export function queryTop3() {
  return request({
    url: '/research/queryTop3',
  })
}


/*
export function queryImg1() {
  return request({
    url: '/research/queryImg1'
  })
}*/
